<template>
  <transition name="fade">
    <div class="modal-container" v-if="show" @click="handleAllClicks">
      <div class="modal vcore_container" ref="modal">
        <div class="modal-close" @click.stop="eventBus.$emit('faqModalClose')">
          <i class="vcore_icon icon-close"></i>
        </div>
        <div class="modal-header vcore_row">
          <div class="vcore_col--xs--12">
            <h2 class="title">Frequently Asked Questions</h2>
          </div>
        </div>
        <div class="modal-body">
          <div v-for="faq in selectedProvider.faqList" :key="faq.question" class="vcore_row section">
            <div class="vcore_col--xs--12"
                 v-html="faq.question">
            </div>
            <div class="vcore_col--xs--12">
              <p v-html="faq.answer"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
import { EventBus } from "@Shared/utils/event-bus";

export default {
  name: "FAQModal",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      eventBus: EventBus
    };
  },
  computed: {
    ...mapGetters(["selectedProvider"]),
    faqs() {
      return this.selectedProvider.faqList.map(faq => {
        return {
          question: faq.question.substring(
            faq.question.lastIndexOf("<b>") + 3,
            faq.question.lastIndexOf("</b>")
          ),
          answer: faq.answer
        };
      });
    }
  },
  watch: {
    show: {
      handler(val) {
        if (val) {
          document.body.classList.add("modal-open");
        } else {
          document.body.classList.remove("modal-open");
        }
      },
      immediate: true
    }
  },
  methods: {
    handleAllClicks(event) {
      if (!this.$refs["modal"].contains(event.target)) {
        this.eventBus.$emit("faqModalClose");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.5s;
  transition-property: height, opacity;
  transition-timing-function: ease;
  overflow: hidden;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.modal-container {
  position: fixed;
  z-index: 2222;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);

  .modal {
    position: relative;
    height: 90%;
    max-height: 655px;
    max-width: 985px;
    top: 5%;
    background-color: white;
    padding: 35px;
    margin: auto;
    // transform: translateY(-50%);
  }

  .modal-body {
    height: 85%;
    overflow-y: auto;
    overflow-x: hidden;
    font-size: 16px;
    padding-bottom: 20px;
  }

  .modal-close {
    position: absolute;
    right: 17px;
    top: 14px;
    font-size: 20px;
    color: #666;
    cursor: pointer;
  }

  .modal-header {
    margin-bottom: 25px;

    .title {
      font-weight: 400;
    }
  }

  .modal-footer {
    margin-top: 25px;
  }

  .section {
    &:not(:first-of-type) {
      margin-top: 25px;
    }

    h6 {
      margin-bottom: 5px;
      font-size: 16px;
    }
  }
}
</style>
